const regexp = /^0+$/

export 	const handleValidateBeeperValue = (beeperCode, isBeeperRequired, t) => {
	if (beeperCode === '' && isBeeperRequired) return t('Cart.BeeperCode.errorMessage')
	if (regexp.test(beeperCode)) {
		return t('Cart.BeeperCode.invalidBeeperCode')
	}
	return null
}
